export default __webpack_public_path__ + "static/media/profile.d25b9579.svg";